import {SmartComponent} from "smart-component-js";
import IconManager from "../utils/IconManager";
import Utility from "../../common/Utility";


class DefaultCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.el = element;
        this.user = this.el.querySelector('div[data-user]')?.getAttribute('data-user');
        this.logged = this.el.querySelector('div[data-logged]')?.getAttribute('data-logged');
        this.notSubscribed = this.el.querySelectorAll('.not-subscribed');
        this.subscribed = this.el.querySelectorAll('.subscribed');
        this.notLogged = this.el.querySelectorAll('.not-logged');
        this.loggedEls = this.el.querySelectorAll('.logged');

        this.init();
    }

    addShowPasswordButton() {
        const passwordInputs = document.querySelectorAll('input[type="password"]');
        passwordInputs.forEach((input) => {
            const wrapper = input.parentElement;
            wrapper.insertAdjacentHTML('beforeend', '<button type="button" class="visibility-icon"></button>');
            this.addPasswordListener(wrapper, input);
        });
    }


    smoothAnchorScroll() {
        document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const hrefAttribute = this.getAttribute('href')?.replace('#', '');
                const element = document.getElementById(hrefAttribute) || document.querySelector(`[data-anchor="${hrefAttribute}"]`);
                element?.scrollIntoView({behavior: 'smooth'});
            });
        });
    }


    checkRegSrc() {
        let regSrc = Utility.getUrlParameter("reg-src");
        if (!regSrc) return;
        document.body.classList.add('fixed-loading');
        this.addLogoutIframe(regSrc);
    }

    addLogoutIframe(regSrc) {
        try {
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = '/user/logout';
            document.body.appendChild(iframe);

            setTimeout(() => {
                window.location.href = `/lp/${regSrc}`;
            }, 3000);
        } catch (e) {
            document.body.classList.remove('fixed-loading');
        }
    }


    addPasswordListener(wrapper, input) {
        wrapper.querySelector('.visibility-icon').addEventListener('click', () => {
            const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
            input.setAttribute('type', type);
            wrapper.classList.toggle('password-visible');
        });
    }

    checkUser() {
        if (this.user && this.user !== "") {
            this.notSubscribed.forEach(el => el.classList.add('hidden'));
            this.subscribed.forEach(el => el.classList.remove('hidden'));
        } else {
            this.notSubscribed.forEach(el => el.classList.remove('hidden'));
            this.subscribed.forEach(el => el.classList.add('hidden'));
        }

    }


    checkLogged() {
        if (this.logged && this.logged.trim() !== '') {
            this.notLogged.forEach(el => el.classList.add('hidden'));
            this.loggedEls.forEach(el => el.classList.remove('hidden'));
            this.notSubscribed.forEach(el => el.classList.remove('hidden'));
        } else {
            this.notLogged.forEach(el => el.classList.remove('hidden'));
            this.loggedEls.forEach(el => el.classList.add('hidden'));
            this.notSubscribed.forEach(el => el.classList.add('hidden'));
        }
    }


    init() {
        window.iconManager = new IconManager();
        this.loadChildComponents(this);
        this.smoothAnchorScroll();
        this.checkRegSrc();
        this.checkLogged();
        this.checkUser();


        document.addEventListener("yxp-form-loaded", () => {
            this.loadChildComponents(this);
            this.addShowPasswordButton();
        });
    }
}

export default DefaultCtrl;
